import type { ComponentPropsWithoutRef } from 'react';
import { LuChevronDown } from 'react-icons/lu';

import { cn } from '@/lib/utils';

const selectBaseStyles = [
  'h-12 w-full appearance-none rounded-1.5xl border px-4 pr-10 text-base',
  'transition-colors outline-none',
  'disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50',
  'bg-white border-gray-200 text-indigo-900',
  'aria-invalid:bg-red-25 aria-invalid:border-red-300',
  'focus:!border-indigo-900 focus:outline-none',
  // Invisible by default, but gives the ring a width so consumers that only
  // pass a ring color (debug panel, dev fast-track) keep a focus indicator
  'focus:ring-2 focus:ring-transparent',
].join(' ');

function Select({
  className,
  children,
  ...props
}: ComponentPropsWithoutRef<'select'>) {
  return (
    <div className="relative">
      <select
        data-slot="select"
        className={cn(selectBaseStyles, className)}
        {...props}
      >
        {children}
      </select>
      <LuChevronDown className="pointer-events-none absolute right-3 top-1/2 size-4 -translate-y-1/2 opacity-50" />
    </div>
  );
}

export { Select };
